import React, { useCallback, useContext, useMemo, useState } from 'react';
import { FolderView } from 'api';
import { ADD_NEW_FOLDER } from 'common/constants/documents';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import RequestFolder from 'components/Documents/components/request/RequestFolder';
import { InformationDashboard409AContext } from 'context/InformationDashboard409AContext';
import AddFolderDialog from 'pages/Documents/components/AddFolderDialog/AddFolderDialog';
import ReferencesSelector from './ReferencesSelector';
import { UpdateDocumentContentProps } from './types';

const UpdateDocumentContent = ({
  formValues,
  setFormValues,
  currentDocuments,
  isCompanyTemplate,
}: UpdateDocumentContentProps) => {
  const [openFolderDialog, setOpenFolderDialog] = useState<boolean>(false);
  const [newFolder, setNewFolder] = useState<FolderView | null>(null);
  const [{ companyInfo }] = useStore() as unknown as UseStoreValues;
  const informationDashboardContext = useContext(InformationDashboard409AContext);
  const { is409a } = informationDashboardContext || {};

  const onCloseFolderDialog = useCallback(() => setOpenFolderDialog(false), []);
  const getNewFolder = useCallback((folder: FolderView) => setNewFolder(folder), []);

  const currentFolders = useMemo(
    () => currentDocuments?.folders?.filter(folder => folder.parent_folder === null),
    [currentDocuments]
  );

  if (!companyInfo || !currentDocuments || isCompanyTemplate) {
    return null;
  }

  return (
    <div>
      <RequestFolder
        setFormValues={setFormValues}
        currentDocuments={currentDocuments}
        setOpenFolderDialog={setOpenFolderDialog}
        newFolder={newFolder ?? undefined}
        companyName={companyInfo?.name}
        formValues={formValues}
      />
      {!is409a && <ReferencesSelector formValues={formValues} setFormValues={setFormValues} />}
      <AddFolderDialog
        open={openFolderDialog}
        onClose={onCloseFolderDialog}
        title={ADD_NEW_FOLDER}
        getNewFolder={getNewFolder}
        currentDocuments={currentDocuments}
        currentFolders={currentFolders}
      />
    </div>
  );
};

export default UpdateDocumentContent;
